const Steps = {
  SELECT_TICKETS: 'select-tickets',
  ALREADY_BOUGHT_TICKET: 'already-bought-ticket',
  PURCHASE_TICKETS: 'purchase-tickets',
  ASSIGN_TICKETS: 'assign-tickets',
  REGISTRATION_COMPLETE: 'registration-complete',
  USER_BLOCKED: 'user-blocked',
  QUICK_REGISTRATION: 'quick-registration',
  LOADING: 'loading',
  JOIN_EVENT: 'join-event',
  SESSIONS: 'sessions',
  SERIES_SELECT_EVENTS: 'series-select-events',
  INFORMATION: 'information',
  CHECKOUT: 'checkout',
  SERIES_REGISTRATION_COMPLETE: 'series-registration-complete',
} as const;

type StepTypes = typeof Steps[keyof typeof Steps];

const stepLabels: Record<StepTypes, string> = {
  [Steps.SELECT_TICKETS]: 'steps.selectTickets',
  [Steps.PURCHASE_TICKETS]: 'steps.checkout',
  [Steps.ASSIGN_TICKETS]: 'steps.assignTickets',
  [Steps.ALREADY_BOUGHT_TICKET]: '',
  [Steps.REGISTRATION_COMPLETE]: '',
  [Steps.LOADING]: '',
  [Steps.QUICK_REGISTRATION]: 'steps.quickRegistration',
  [Steps.USER_BLOCKED]: '',
  [Steps.JOIN_EVENT]: '',
  [Steps.SESSIONS]: 'steps.sessions',
  [Steps.SERIES_SELECT_EVENTS]: 'steps.series',
  [Steps.INFORMATION]: 'steps.information',
  [Steps.CHECKOUT]: 'steps.checkout',
  [Steps.SERIES_REGISTRATION_COMPLETE]: '',
};

const stepLabelsFree: Record<StepTypes, string> = {
  ...stepLabels,
  [Steps.SELECT_TICKETS]: 'stepsFree.selectRegistrationType',
  [Steps.PURCHASE_TICKETS]: 'stepsFree.registration',
  [Steps.ASSIGN_TICKETS]: 'stepsFree.assignRegistrations',
};

export { StepTypes, Steps, stepLabels, stepLabelsFree };
